export default Object.freeze({
  UNSET: 0,
  STATUS_HISTORY: 1,
  APPROVE: 2,
  OBJECT: 3,
  CANCEL: 4,
  CONTRACT_HISTORY: 5,
  RETURN_TO_PREVIOUS_STATUS: 6,
  DOCUMENT: 7,
  BITACORA: 8,
  BITACORA_HISTORY: 9
});
